import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';
import Carousel from '../../../sharedComponents/carousel/Carousel.vue';

export default {
  data() {
    return {
      pagePers: null,
      pageRules: null,
      dialogPers: false,
      dialogRules: false,
      leader: false,
    };
  },
  components: {
    Surveys,
    Notifications,
    Carousel,
  },
  computed: {
    sales() {

    },
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_pers === true
          && state.user
          && !state.user.pers_at
      );
    },
    requireRules() {
      const { state } = this.$store;
      return !!(
        state.settings.profile_rules === true
          && state.user
          && this.$store.state.agreedRules === false
      );
    },
    account() {
      return this.$store.state.user.account;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userIsChecked() {
      return this.$store.state.user ? this.$store.state.user.is_checked : null;
    },
    isNeedToCheck() {
      return this.$store.state.settings.registration_blocked;
    },
    isBlockedCheck() {
      return this.isNeedToCheck && !this.userIsChecked;
    },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null);
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
  },
  methods: {
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          this.$store.dispatch('GetProfile');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
        });
    },
    ConfirmRules() {
      this.$store.dispatch('AgreeingRules');
    },
    getLeader() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/leader/my', { profile_id: this.user.profile_id })
        .then((response) => {
          app.leader = response.data.data;
        });
    },
  },
  created() {
    // this.user && this.$store.dispatch('surveys/GetSurveys', this.user.profile_id);
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetSettings');
  },

  watch: {
    user() {
      if (this.user) {
        this.$store.dispatch('notifications/GetNotifications', this.user.profile_id);
        this.isBannersOn && this.$store.dispatch('banners/GetBannersList');

        this.$store.dispatch('CheckAgreedRules').then(() => {
          if (this.requirePers || this.requireRules) {
            this.LoadPers();
          }
        });
      }
    },
  },
};
